import { render, staticRenderFns } from "./situation.vue?vue&type=template&id=2078bb9f&scoped=true"
import script from "./situation.vue?vue&type=script&lang=js"
export * from "./situation.vue?vue&type=script&lang=js"
import style0 from "./situation.vue?vue&type=style&index=0&id=2078bb9f&prod&lang=scss&scoped=true"
import style1 from "./situation.vue?vue&type=style&index=1&id=2078bb9f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_css-loader@6.11.0_webpack@5.104.1__lodash@4.17.23_headix2sp25l5o3ug274cuzz24/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2078bb9f",
  null
  
)

export default component.exports